<!-- 
TELA PARA SELECAO DE NOTAS DE ORIGEM (ENTRADA OU SAIDA)

PARAMETROS ENTRADA:
codpart: codigo participante
operacaonf: E/S

ORDS:
invoice/origem/:operacao/:codpart


-->


<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    props: {
      operacaonf: { type: String },
      codpart: { type: [ String, Number ] },
    },

    data () {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,

            selectedNf: [],  //codigos de notas selecionadas

            searchString: '',
        }
    },

    computed: {
        nfList: function () {
            return this.$store.getters.getNfOrigem
        },
    },

    methods: {
        handleSearch() {
            //efetua a pesquisa
            if (this.searchString === '') {
                this.filter = ''
            } else {
                this.filter = '{"$or":[{"nf":{"$eq":"' + this.searchString + '"}}]}'
            }
            this.loadData()
        },
        
        async loadData() {
            await this.$store.dispatch('loadNfOrigem', { operacaoNf: this.operacaonf, codpart: this.codpart, filter: this.filter} )
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
            this.updateListSelected()
        },

        updateListSelected() {
            //ao carregar as notas no loadData, marca as notas que ja foram selecionadas            
            for (var x = 0; x < this.nfList.length; x++) {
                this.$set(this.nfList[x], 'selected', 'N')
                // this.nfList[x].selected = 'N'
                if (this.selectedNf.findIndex(obj => obj.codnf == this.nfList[x].codnf) >= 0) {
                    this.nfList[x].selected = 'S'
                }
            }
        },

        handleSelectNf(codnf, chave, serie, nf) {
            //botao de selecao da nf 
            //adiciona a nf selecionada no array "selectNf"            
            if (this.selectedNf.findIndex(obj => obj.codnf == codnf) >= 0) {
               this.handleUnselectNf(codnf)
            } else {
                var nf = { 
                    codnf: codnf, 
                    chave: chave,
                    serie: serie,
                    nf: nf
                    }                
                this.selectedNf.push(nf)
            }
            // console.log(this.selectedNf)
        },

        handleUnselectNf(codnf) {
            //botao para remover uma nf selecionada
            let idx = -1
            for (var x = 0; x < this.selectedNf.length; x++) {
                if (this.selectedNf[x].codnf === codnf) {
                    idx = x
                }
            }
            if (idx >= 0) {
                this.selectedNf.splice(idx, 1)
            }
        },

        textST (value) {
            return getText(value, this.metadata.nf.stnf)
        },

        operacaoNf (value) {
            return getText(value, this.metadata.nf.operacaonf)
        },

        data (value) {
            return formatDate(value)
        },        

        handleAddNotas () {
            //envia as notas selecionadas para o formulario chamador
            // for (var x = 0; x < this.nfList.length; x++) {
            //     if (this.nfList[x].selected === 'S') {
            //         var nf = { 
            //             codnf: this.nfList[x].codnf, 
            //             chave: this.nfList[x].chave
            //             }
            //         this.selectedNf.push(nf)
            //     }
            // }
            this.$emit('closeform', this.selectedNf)
        },

        closeForm () {
            this.$emit('closeform')
        }

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    components: {
        BarList
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
    <div id="mymodal" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container">
            <div class="nb-modal-header">
                <h4 class="def-title">Pesquisar Notas de Origem</h4>
                <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <div class="col-md-4 col-12">
                        <div class="input-group">
                            <input ref="pesquisa" class="form-control form-control-sm" type="text" :placeholder="'Pesquisar'" v-model="searchString" @keyup.enter="handleSearch()">
                            <span class="input-group-btn">
                                <button class="btn btn-sm btn-outline-secondary" tabindex="1" style="margin-right: 5px" type="submit" @click="handleSearch()">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                </button>
                            </span>
                        </div>
                        <span class="badge badge-yellow" style="margin-top: 10px">Efetue a pesquisa pelo número da nota</span>
                    </div>
                    <div class="col-md-8 col-12">
                        <div class="float-right">
                        </div>
                    </div>
                </div>
                <br>
                <alert v-if="nfList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="nf in nfList" v-bind:key="nf.codnf">
                    <div class="mark-gray"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-10 col-10">
                                <div class="row">
                                    <div class="col-md-4 col-6">
                                        <span class="lbl-title-produto">{{ nf.nome }}</span>
                                        <!-- <span class="float-right badge" :class="[{'badge-green': nf.stnf=='10'||nf.stnf=='11'},{'badge-orange': nf.stnf=='00'},{'badge-blue': nf.stnf=='01'},{'badge-red': nf.stnf=='90'||nf.stnf=='92'||nf.stnf=='50'}]" >{{ textST(nf.stnf) }}</span> -->
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <label class="lbl-list">Número</label>
                                        <span class="data-list">{{ nf.serie }} / {{ nf.nf }}</span>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <label class="lbl-list">Data</label>
                                        <span class="data-list">{{ data(nf.data) }}</span>
                                    </div>
                                    <div class="col-md-4 col-6">
                                        <label class="lbl-list">Natureza</label><span class="data-list">{{ nf.descricao }}</span>
                                    </div>
                                    <div class="col-md-6 col-6">
                                        <span class="data-list">{{ nf.chave }}</span>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <span class="data-list">{{ operacaoNf(nf.operacaonf) }}</span>
                                    </div>
                                    <div class="col-md-2 col-3">
                                        <label class="lbl-list">Total</label><span class="data-list">{{ nf.totger | format }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 col-2">
                                <input-switch type="success" label="" v-model="nf.selected" value-checked="S" value-unchecked="N" @input="handleSelectNf(nf.codnf, nf.chave, nf.serie, nf.nf)"></input-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nb-modal-scrollable-footer">
                <v-button :tabindex="1" label="Adicionar Selecionadas" :nb-btdef="true" title="" icon="fa-plus" @click="handleAddNotas()"></v-button>
                <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm()"></v-button>
            </div>
        </div>
    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms/nf-form-origem.vue